import React from 'react';

import ComponentInitialiser from '@scripts/react-common/percentage-figure.jsx';


export default ComponentInitialiser(React);

